import { render, staticRenderFns } from "./MyTeamDetails.vue?vue&type=template&id=00a094b7&scoped=true&"
import script from "./MyTeamDetails.vue?vue&type=script&lang=js&"
export * from "./MyTeamDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyTeamDetails.vue?vue&type=style&index=0&id=00a094b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a094b7",
  null
  
)

export default component.exports